<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14unkS6/tc-custom/9781398466593.jpg?1705541169370" alt="This image is the cover for the book Lorrie and I"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lorrie and I
      </h1>
      <p class="bookDescription body article font2">
        <p>“When Lorrie looked at me in a bath of blood, he quickly went to the laundry and took a big clean towel wet with hot water. He carefully wrapped me up. He then gently bathed me in it. I looked Lorrie in his eyes and felt comforted. Lorrie carried me to his office and placed a silky blanket over me to keep me warm. He put me in a paper box lined with a towel. I felt no pain! The journey to the vet took 15 minutes. Lorrie kept singing to me and touching my head and shoulder. It seemed a very long journey as he drove steadily along on the road.” Coco the feline knew his final hour is coming; it didn’t end his longing for the comfort and touches of his master!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Che Kwok Wong
      </h2>
      
      <p class="authorDescription body article">David Che Kwok Wong has a Master Degree of Education and a Master Degree of Development Management. He enjoys spending most of his time working among ordinary people. He loves listening and associating with people, a great privilege to be called their friend. He loves travelling and keeping his journal with him at all times.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e6a3bf4